import { ProposalReviewPageContent } from '../components/management/proposalReview/ProposalReviewPageContent'

export const ProposalReviewPage = () => {
  return <ProposalReviewPageContent />
}
